// useCookie.js
import { useState } from "react";

// Helper to get a cookie by name
function getCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  console.log('Status:', "Get Cookie set successfully! value="+ (match ? decodeURIComponent(match[2]) : null));
  return match ? decodeURIComponent(match[2]) : null;
}

export function useCookie(name, defaultValue = "user_id"+String(Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000)) {
  const [value, setValue] = useState(() => getCookie(name) || defaultValue);

  const updateCookie = (newValue, days = 1) => {
    setValue(newValue);
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${encodeURIComponent(newValue)}; expires=${expires.toUTCString()}; path=/`;
    console.log('Status:', "Cookie set successfully! value="+newValue);
  };

  const deleteCookie = () => {
    setValue("");
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  };

  return [value, updateCookie, deleteCookie];
}